import React, { useMemo } from 'react';
import { useQuery } from 'react-query';
import {
  DialogContent,
  Box,
  Typography,
  Grid,
  Stack,
} from '@mui/material';
import { SkeletonNotaFiscal } from './SkeletonNotaFiscal';
import 'moment/locale/pt-br';
import axiosClient from '../../../../../lib/axios';
import DialogFullScreen from '../../../../../components/DialogFullScreen';
import CardFiscaisResumo from './CardFiscaisResumo';
import CardStatus from './CardStatus';
import CardNotaFiscalItens from './CardNotaFiscalItens';
import { INotaFiscal } from '../../../../../types/api/fiscal/detalhe-nfe-entrada';

interface DialogNotaFiscalProps {
  open: boolean;
  handleClose: () => void;
  notaFiscalId: string;
}
export const DialogNotaFiscal: React.FC<DialogNotaFiscalProps> = ({
  open,
  handleClose,
  notaFiscalId,
}) => {


  const { data: notaFiscal, isLoading, error } = useQuery<INotaFiscal>(
    ['nota-fiscal', notaFiscalId],
    async () => {
      try {
        const response = await axiosClient.get(`/fiscal/nfes-entrada/${notaFiscalId}`);
        return response.data;
      } catch (err) {
        console.error('Erro ao buscar nota fiscal:', err);
        throw err;
      }
    },
    {
      staleTime: 1000 * 60 * 5,
      retry: 1,
    }
  );

  const itens = useMemo(() => {
    return notaFiscal?.itens || [];
  }, [notaFiscal?.itens]);

  return (
    <DialogFullScreen
      open={open}
      handleClose={handleClose}
      title="Detalhe da NFe Entrada"
    >
      <DialogContent sx={{ p: 0, overflow: 'hidden' }}>
        <Box sx={{ overflowY: 'auto', height: '100%' }}>
          {
            isLoading &&
            <SkeletonNotaFiscal />
          }
          {
            !isLoading && notaFiscal &&
            <Grid container spacing={2}>
              <Grid container size={{ xs: 12, md: 4 }} spacing={2} alignSelf="flex-start">
                <Grid size={{ xs: 12 }}>
                  <CardFiscaisResumo data={notaFiscal} />
                </Grid>
              </Grid>
              <Grid size={{ xs: 12, md: 8 }}>
                <Stack spacing={3}>
                  <CardStatus fiscal={notaFiscal} />
                  <CardNotaFiscalItens itens={itens} />
                </Stack>
              </Grid>
            </Grid>
          }
          {
            !isLoading && !notaFiscal && !error &&
            <Box textAlign="center" p={4}>
              <Typography color="error" variant="h6">
                Ocorreu um erro ao carregar os dados da nota fiscal.
              </Typography>
              <Typography color="textSecondary" sx={{ mt: 1 }}>
                Tente novamente mais tarde.
              </Typography>
            </Box>
          }
        </Box>
      </DialogContent>
    </DialogFullScreen>
  );
};



